import React from 'react';
import styled from '@mui/system/styled';
import { Box, Card, IconButton, Tooltip, useTheme } from '@mui/material';
import { BookingStatus } from '../../../../../redux/booking/bookingSlice';
import { downloadImage } from '../../../../../service/api/bookingApi';

export const StyledUserCard = styled(Card)`
  display: flex;
  border: none;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding: 2px 10px 2px 5px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: 0.3s;
  box-shadow: none;
  max-width: 280px;

  @media (max-width: 1000px) {
    margin: 0 5px;
    padding: 2px 5px 2px 0px;
    font-size: 12px;
    font-weight: 500;
    max-width: 160px;
  }
`;

export enum CardTypeEnum {
  EMAIL = 'EMAIL',
  MOBILE = 'MOBILE',
  TOPIC = 'TOPIC',
  REFERENCE = 'REFERENCE',
}

export interface BookingTypeProps {
  type: CardTypeEnum;
  text: string;
  bookingStatus: BookingStatus;
  url?: string;
}

export default function ContactCard({ text, type, bookingStatus, url }: BookingTypeProps) {
  let icon: React.ReactNode | null = null;
  const theme = useTheme();

  if (type === CardTypeEnum.EMAIL) {
    icon = <img src="/assets/icons/booking-user-email.svg" alt="email" />;
  } else if (type === CardTypeEnum.MOBILE) {
    icon = <img src="/assets/icons/booking-user-mobile.svg" alt="mobile" />;
  } else if (type === CardTypeEnum.TOPIC) {
    icon = <img src="/assets/icons/booking-user-tag.svg" alt="topic" />;
  } else if (type === CardTypeEnum.REFERENCE) {
    icon = <img src="/assets/icons/booking-reference.svg" alt="reference" />;
  }

  return (
    <StyledUserCard>
      <Box px="2px" display="flex" alignItems="center">
        {icon}
      </Box>
      <Tooltip
        title={text}
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: '#2A3C67',
              color: 'white',
            },
          },
        }}
      >
        <Box
          sx={{
            background:
              bookingStatus === BookingStatus.CANCELED
                ? 'linear-gradient(180deg, #85B5C9 0%, #6CA3AC 100%)'
                : 'none',
            color:
              bookingStatus === BookingStatus.CANCELED ? 'transparent' : theme.palette.primary.main,

            WebkitBackgroundClip: bookingStatus === BookingStatus.CANCELED ? 'text' : 'unset',
            backgroundClip: bookingStatus === BookingStatus.CANCELED ? 'text' : 'unset',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {text}
        </Box>
      </Tooltip>
      {type === CardTypeEnum.REFERENCE && url && (
        <Box>
          <IconButton
            size="small"
            color="primary"
            onClick={async () => {
              downloadImage(url, text);
            }}
          >
            <img src="/assets/icons/payment-receipt.svg" alt="copy" />
          </IconButton>
        </Box>
      )}
    </StyledUserCard>
  );
}
